/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountComboModifierRequestSchema } from "./calculateDiscountComboModifierRequestSchema.ts";

export const calculateDiscountComboGroupModifierRequestSchema = z.object({
	group: z.uuid(),
	modifiers: z.array(calculateDiscountComboModifierRequestSchema),
});
